<mat-toolbar style="background-color: #fff; border-top: solid 2px #E9E9E9;">
  <ng-container>
    <button id="homeButton" mat-button class="custom-menu-nav-item" [routerLink]='[""]' [routerLinkActive]="'active'" [routerLinkActiveOptions]={exact:true} (click)="clickEvent('Home')">
      <span class="menu-item-css" [routerLink]='["home"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        Home
      </span>
    </button>
    <button id="searchButton" *ngIf="isAuthenticated && !obtainingPermission" mat-button class="custom-menu-nav-item" [routerLink]='["search"]' [routerLinkActive]="'active'" (click)="clickEvent('On Demand Search')">
      <span class="menu-item-css" [routerLink]='["search"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        On-Demand Search
      </span>
    </button>
    <button id="lineItemButton" *ngIf="isAuthenticated && !obtainingPermission" mat-button class="custom-menu-nav-item" [routerLink]='["lineitemlist"]' [routerLinkActive]="'active'" [routerLinkActiveOptions]={exact:true} (click)="clickEvent('LineItemList')">
      <span class="menu-item-css" [routerLink]='["lineitemlist"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        Line-Item List Cross-References
      </span>
    </button>
  </ng-container>
  <ng-container>
    <button mat-button class="custom-menu-nav-item" [ngClass]="{'active-m': showActiveClass}" [matMenuTriggerFor]="appMenu" id="reportsButton">
      <span class="menu-item-css" [ngClass]="{'menu-item-select': showActiveClass}">
        Reports
      </span>
    </button>
    <mat-menu #appMenu="matMenu" overlapTrigger="false" style="margin:0px; color:black;">
      <button [routerLink]='["cccReport"]' mat-menu-item>Crosses, Category, and Confidence</button>
      <ng-container *ngFor="let group of displayedReportGroups">
        <button (click)="navigateTo(report.id,report.name,report.type)" mat-menu-item *ngFor="let report of group.reports">{{report.name}}</button>
      </ng-container>
      <button *ngIf="adminUser" mat-menu-item (click)="exportDisputedReport()">Disputed Crosses Report</button>
    </mat-menu>
  </ng-container>
  <ng-container>
    <button id="batchButton" *ngIf="internalUser" mat-button class="custom-menu-nav-item" [routerLink]='["batch"]' [routerLinkActive]="'active'" [routerLinkActiveOptions]={exact:true} (click)="clickEvent('Batch')">
      <span class="menu-item-css" [routerLink]='["batch"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        Batch
      </span>
    </button>
  </ng-container>
  <ng-container>
    <button id="differingButton" *ngIf="adminUser" mat-button class="custom-menu-nav-item" [routerLink]='["differingunspsc"]' [routerLinkActive]="'active'" [routerLinkActiveOptions]={exact:true} (click)="clickEvent('Batch')">
      <span class="menu-item-css" [routerLink]='["differingunspsc"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        Differing UNSPSC
      </span>
    </button>
  </ng-container>
  <ng-container *ngIf="splitService.isOn('Request_Nav_Tab') && internalUser">
    <button id="requestButton" mat-button class="custom-menu-nav-item" [routerLink]='["request"]' [routerLinkActive]="'active'" [routerLinkActiveOptions]={exact:true} (click)="clickEvent('Request')">
      <span class="menu-item-css" [routerLink]='["request"]' [routerLinkActive]="'menu-item-select'" [routerLinkActiveOptions]={exact:true}>
        Request
      </span>
    </button>
  </ng-container>
</mat-toolbar>
